import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'
import LandingDropdown from '../defaultComponents/LandingDropdown.jsx'
import DeptCard from '../defaultComponents/DeptCard.jsx'

export default function Landing() {
  const [permissions, setPermissions] = React.useState("")
  const [currentUser, setCurrentUser] = React.useState("")
  const authoriseUser = async () => {
    try {
      //https://ic360portalbackend.azurewebsites.net
      const response = await fetch("https://ic360portalbackend.azurewebsites.net/api/auth/checkToken", {
        method: "GET",
        headers: {
          'Content-type': 'application/JSON',
        },
        credentials: "include",
      })

      const data = await response.json();
      if (data.status === "Auth Successful") {
        setPermissions(data.permissions)
        setCurrentUser(data.currentUser)
        sessionStorage.setItem('currentUser', data.currentUser);
      } else {
        setPermissions("")
        setCurrentUser(data.currentUser)
        sessionStorage.removeItem('currentUser');
      }

    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    authoriseUser()
  }, [])

  return (<>

    <Navbar key={Date.now()} />
    <div className="all-page-background">

      <div className="landing-wrapper">

        <div className="landing-box">
          <div className="landing-title">IC360 Portal</div>
          <div className="landing-box-desc">Empowering Business.</div>
          <div className="landing-line"></div>

          <div className='landing-dropdown-container'>
            <LandingDropdown />
          </div>

        </div>

        <div className='landing-cards-container'>
          {permissions === 'Papaya' &&
            <>

              <DeptCard
                deptName="Assets"
                deptButtons={['Client Assets', 'Hire Board', 'Asset Returns']}
                deptButtonRoutes={['/AssetHire/Inventory', '/SNRMGMT/AssetPublicDashboard', '/SNRMGMT/AssetReturnsInternal']}
                image="dept-image-assets"
              />

              <DeptCard
                deptName="Software"
                deptButtons={['Devices',]}
                deptButtonRoutes={['/HR/DeviceDetails']}
                image="dept-image-software"
              />

              <DeptCard
                deptName="Management"
                deptButtons={['Business Dashboard', 'Allroad Daily', 'Allroad Summary']}
                deptButtonRoutes={['/SNRMGMT/MasterDashboard', '/SNRMGMT/Dashboard/Allroad/daily', '/SNRMGMT/Dashboard/Allroad/summary']}
                image="dept-image-snrmgmt"
              />

              <DeptCard
                deptName="Engineering"
                deptButtons={["Timesheets"]}
                deptButtonRoutes={["/ENG/Timesheets"]}
                image="dept-image-engineering"
              />

              <DeptCard
                deptName="Accounts"
                deptButtons={["Timesheets"]}
                deptButtonRoutes={["/Accounts/Timesheets"]}
                image="dept-image-estimating"
              />

              <DeptCard
                deptName="Human Resources"
                deptButtons={["Leave Calendar"]}
                deptButtonRoutes={["/leaveCalendar"]}
                image="dept-image-hr"
              />

              <DeptCard
                deptName="AllRoad"
                deptButtons={["Sydney Trains"]}
                deptButtonRoutes={["/ALLROAD/SydneyTrainsDashboard"]}
                image="dept-image-allroad"
              />

              <DeptCard
                deptName="Forms"
                deptButtons={['Employee Forms', 'Business Forms']}
                deptButtonRoutes={['/DefaultUser/EmployeeForms', '/DefaultUser/AllForms']}
                image="dept-image-misc"
              />
            </>
          }
          {/* SNR MGMT */}
          {permissions === 'Strawberry' &&
            <>

              <DeptCard
                deptName="Management"
                deptButtons={['Business Dashboard']}
                deptButtonRoutes={['/SNRMGMT/MasterDashboard']}
                image="dept-image-snrmgmt"
              />

            </>
          }

          {permissions === 'Watermelon' &&
            <>
              <DeptCard
                deptName="Engineering"
                deptButtons={[/*"PO Form",*/ "Timesheets", /*"Dashboard"*/]}
                deptButtonRoutes={[/*"/ENG/PO",*/ "/ENG/Timesheets", /*"/ENG/Dashboard"*/]}
                image="dept-image-engineering"
              />
            </>}

          {
            permissions === 'ALLROAD-DEFAULT' &&
            <DeptCard
              deptName="AllRoad"
              deptButtons={["Sydney Trains"]}
              deptButtonRoutes={["/ALLROAD/SydneyTrainsDashboard"]}
              image="dept-image-allroad"
            />
          }

          {
            permissions === 'Kebab' &&
            <DeptCard
              deptName="AllRoad"
              deptButtons={["Sydney Trains"]}
              deptButtonRoutes={["/ALLROAD/SydneyTrainsDashboard"]}
              image="dept-image-allroad"
            />
          }

          {
            permissions === 'Mango' &&
            <DeptCard
              deptName="Accounts"
              deptButtons={["Timesheets"]}
              deptButtonRoutes={["/Accounts/Timesheets"]}
              image="dept-image-estimating"
            />
          }

          {
            currentUser === "IC360LEAVE" &&
            <DeptCard
              deptName="Human Resources"
              deptButtons={["Leave Calendar"]}
              deptButtonRoutes={["/leaveCalendar"]}
              image="dept-image-hr"
            />
          }
        </div>
      </div>

      <Footer />
    </div>
  </>
  )
}
